

export const countryMap = {
    us: 'usa',
    ca: 'can',
    canada: 'can'
};

export const defaultCountry = countryMap.us;